import {
  signalStoreFeature,
  withState,
  withMethods,
  patchState,
} from '@ngrx/signals';
import { IRole } from '../../app/features/roles-management/interfaces';
import { ReportStatus } from '../../app/shared/enums';

interface UiState {
  searchQuery: string;
  roleFilter: string[];
  userFilter: 'all' | 'assigned' | 'notAssigned';
  selectedRoles: string[];
  selectedStatuses: ReportStatus[];
}
const initialState: UiState = {
  searchQuery: '',
  roleFilter: [],
  userFilter: 'all',
  selectedRoles: [],
  selectedStatuses: [],
};

export function withUiStates() {
  return signalStoreFeature(
    withState(initialState),
    withMethods((store) => {
      function setSearchQuery(searchQuery: string): void {
        patchState(store, { searchQuery });
      }

      function filteredRoles(filters: string[], arrayData: unknown[]): void {
        if (filters.length === 0) return;
        const filtered = arrayData.filter((element) =>
          filters.includes((element as IRole).id),
        );
        patchState(store, { roleFilter: filtered as string[] });
      }

      function toggleRole(role: IRole): void {
        const currentFilters = store.roleFilter();
        const exists = currentFilters.includes(role.id);

        patchState(store, {
          roleFilter: exists
            ? currentFilters.filter((id) => id !== role.id)
            : [...currentFilters, role.id],
        });
      }

      function setUserFilter(filter: 'all' | 'assigned' | 'notAssigned') {
        patchState(store, { userFilter: filter });
      }

      function clearFilters(filter: string): void {
        patchState(store, { [filter]: [] });
      }

      const clearSearch = () => {
        patchState(store, {
          searchQuery: '',
          roleFilter: [],
          selectedStatuses: [],
        });
      };

      function toggleSelectedRole(role: IRole): void {
        const currentSelected = store.selectedRoles();
        const roleId = role.id;
        const isSelected = currentSelected.includes(roleId);

        patchState(store, {
          selectedRoles: isSelected
            ? currentSelected.filter((id) => id !== roleId)
            : [...currentSelected, roleId],
        });
      }

      function isRoleSelected(role: IRole): boolean {
        return store.selectedRoles().includes(role.id);
      }

      function clearSelectedRoles(): void {
        patchState(store, { selectedRoles: [] });
      }

      function setSelectedStatuses(statuses: ReportStatus[]) {
        patchState(store, { selectedStatuses: statuses });
      }

      function clearSelectedStatuses() {
        patchState(store, { selectedStatuses: [] });
      }

      return {
        setSearchQuery,
        clearSearch,
        filteredRoles,
        toggleRole,
        setUserFilter,
        clearFilters,
        toggleSelectedRole,
        isRoleSelected,
        clearSelectedRoles,
        setSelectedStatuses,
        clearSelectedStatuses,
      };
    }),
  );
}
